module.exports = __webpack_public_path__ + "img/plan_default.001e8e24.png";